import { OrganizationRole } from "@secure-caseworker/shared";

// Re-export request types
export * from "./request";

export interface OrganizationUser {
  id: string;
  userId: string;
  organizationId: string;
  role: OrganizationRole;
  invitedBy?: string;
  invitedAt: string;
  user?: {
    id: string;
    email: string;
    fullName?: string;
  };
}

export interface Organization {
  id: string;
  name: string;
  description?: string;
  createdBy: string;
  createdAt: string;
  memberCount: number;
  caseCount: number;
  isBeta: boolean;
  logoUrl?: string;
  planId: string;
}

export interface OrganizationPublic {
  id: string;
  name: string;
  logoUrl?: string;
}

export interface CreateOrganizationDto {
  name: string;
  description?: string;
  adminUserIds?: string[];
}

export interface UpdateOrganizationDto {
  name?: string;
  description?: string;
}

export interface AddMemberDto {
  userId: string;
  role?: OrganizationRole;
}

export interface MemberDetail {
  id: string;
  userId: string;
  email: string;
  fullName: string | null;
  role: OrganizationRole;
  createdAt: string;
  isPending: boolean;
  invitationId?: string;
  assignedCases: Array<{
    caseId: string;
    caseTitle: string;
    assignedAt: string;
  }>;
}

// Case Types
export enum CaseStatus {
  OPEN = "open",
  IN_PROGRESS = "in_progress",
  CLOSED = "closed",
  ARCHIVED = "archived",
}

export enum CasePriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  URGENT = "urgent",
}

export interface CaseAssignment {
  id: string;
  caseId: string;
  userId: string;
  assignedBy: string;
  assignedAt: string;
  removedAt?: string;
  user?: {
    id: string;
    email: string;
    fullName?: string;
  };
}

export interface Case {
  id: string;
  title: string;
  description?: string;
  status: CaseStatus;
  priority: CasePriority;
  organizationId: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  closedAt?: string;
  fileCount: number;
  formCount: number;
  assignmentCount: number;
  assignments?: CaseAssignment[];
}

export interface CreateCaseDto {
  title: string;
  description?: string;
  organizationId: string;
  status?: CaseStatus;
  priority?: CasePriority;
}

export interface UpdateCaseDto {
  title?: string;
  description?: string;
  status?: CaseStatus;
  priority?: CasePriority;
}

export interface AssignUserToCaseDto {
  userId: string;
}

export interface AssignUsersToCaseDto {
  assignments: AssignUserToCaseDto[];
}

// Folder Permission Types
export type FolderPermission = "none" | "read" | "modify";

export interface Folder {
  id: string;
  name: string;
  caseId: string;
  parentId: string | null;
  clientPermission: FolderPermission;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

// User Type
export interface User {
  id: string;
  email: string;
  fullName?: string;
  createdAt: string;
  updatedAt: string;
  metadata: Record<string, any>;
  organizations: { id: string; role: OrganizationRole }[];
}

export interface UpdateUserDto {
  fullName?: string;
  email?: string;
  password?: string;
  timezone?: string;
}
